export interface MenuItemKeys {
  digitalStylist: string
  donateVoucher: string
  paymentCredits: string
  hmxklarna: string
  hmxklarnaActivation: string
  mySettings: string
  reviewItems: string
  clubInfoPage: string
  pointsHistoryPage: string
  customerService: string
  logout: string
  inviteFriendPage: string
  purchases: string
}

export interface NewMenuItemKeys {
  purchases: string
  review: string
  mysettings: string
  payment: string
  klarna: string
  pointshistory: string
  inviteafriend: string
  info: string
  customerservice: string
  signout: string
  helpus: string
}

export interface NewMenuKeys {
  myorders: string
  rateandreview: string
  accountdetails: string
  paymentinformation: string
  paymentsklarna: string
  mypoints: string
  inviteafriend: string
  membership: string
  customerservice: string
  signout: string
  helpusimprove: string
}

export const NEW_MENU_ITEM_KEYS: NewMenuItemKeys = {
  purchases: 'purchases',
  review: 'review',
  mysettings: 'mysettings',
  payment: 'payment',
  klarna: 'klarna',
  pointshistory: 'pointshistory',
  inviteafriend: 'inviteafriend',
  info: 'info',
  customerservice: 'customerservice',
  signout: 'signout',
  helpus: 'helpus',
}

export const MENU_ITEM_KEYS: MenuItemKeys = {
  digitalStylist: 'digitalStylist',
  donateVoucher: 'donateVoucher',
  paymentCredits: 'paymentCredits',
  hmxklarna: 'hmxklarna',
  hmxklarnaActivation: 'hmxklarnaActivation',
  mySettings: 'mySettings',
  reviewItems: 'reviewItems',
  clubInfoPage: 'clubInfoPage',
  pointsHistoryPage: 'pointsHistoryPage',
  customerService: 'customerService',
  logout: 'logout',
  inviteFriendPage: 'inviteFriendPage',
  purchases: 'purchases',
}

export const NEW_MENU_KEYS: NewMenuKeys = {
  myorders: 'myorders',
  rateandreview: 'rateandreview',
  accountdetails: 'accountdetails',
  paymentinformation: 'paymentinformation',
  paymentsklarna: 'paymentsklarna',
  mypoints: 'mypoints',
  inviteafriend: 'inviteafriend',
  membership: 'membership',
  customerservice: 'customerservice',
  signout: 'signout',
  helpusimprove: 'helpusimprove',
}

export interface MenuSectionKeys {
  account: string
  services: string
  help: string
}

export const MENU_SECTION_KEYS: MenuSectionKeys = {
  account: 'myAccount',
  services: 'myServices',
  help: 'help',
}
